<!-- [style.width.vw]="width" -->
<div
  class="container" [ngClass]="typePopup"
  [@showHide]="{ value: animationState, params: { height: height } }"
  (@showHide.start)="onShowHide($event)"
  (@showHide.done)="onShowHide($event)"
  >
  @for (popupMenuItem of popupMenuItems; track popupMenuItem) {
    <aa-popup-menu-item
      class="popitem"
      [typePopup]="typePopup"
      [popupMenuItem]="popupMenuItem"
    ></aa-popup-menu-item>
  }
</div>
